import { TabItem } from 'app/layout/common/tabs-nav/tab-item.types';
import { pluralize } from 'app/shared/utils/string-utils';

export function outstandingActionsTooltip(count: number): string {
    return `${count} outstanding ${pluralize(count, 'action', 'actions')}`;
}

export function mapTabsWithBadges(
    tabs: readonly TabItem[],
    badgesByTabId: Partial<Record<string, number | null>>,
    badgeTooltipsByTabId?: Partial<Record<string, string | ((count: number) => string)>>
): readonly TabItem[] {
    return tabs.map((tab) => {
        const count = badgesByTabId[tab.id];
        const badgeCount = count != null && count > 0 ? count : undefined;
        if (badgeCount == null) {
            return tab;
        }
        const tooltipSpec = badgeTooltipsByTabId?.[tab.id];
        const badgeTooltip =
            typeof tooltipSpec === 'function' ? tooltipSpec(badgeCount) : tooltipSpec;
        return badgeTooltip != null ? { ...tab, badgeCount, badgeTooltip } : { ...tab, badgeCount };
    });
}
